export const __HousesDetailLang = {
    share: 'اشتراک گذاری',
    back: 'برگشت',
    unit_specifications: 'مشخصات واحد',
    buildingType: 'نوع واحد:',
    shared: 'اشتراکی',
    independent: 'مستقل',
    month: 'ماه',
    facilities: 'امکانات:',
    limitations: 'محدودیت ها:',
    other_conditions: 'سایر شرایط:',
    timing: 'زمانبندی',
    duration: 'مدت زمان اقامت:',
    area: 'منطقه',
    place: 'محله:',
    see: 'مشاهده حدود منطقه در google map',
    year: 'ساله',
    resident_gender: 'صاحبخانه',
    roommate_gender: 'همخانه',
    tel: 'ارتباط در تلگرام',
    copy_alert: 'آدرس خانه مورد نظر در کلیپ بورد دستگاه ذخیره شد',
    tenantTel: 'آیدی تلگرام پروفایل موردنظر',
    tenantDescTel: 'آیدی تلگرام کاربر',
    sendMessage: 'ارسال پیام در تلگرام',
    telDesc: 'شما می‌توانید برای کسب اطلاعات بیشتر و هماهنگی با کاربر مورد نظر در تلگرام در ارتباط باشید.',
    copyTelIDAlert: 'آیدی تلگرام کاربر در کلیپ بورد دستگاه ذخیره شد',
};
